<template>
  <dynamic-object-form-structure
    :object-uuid="objectUUID"
    :object-layer="objectLayer"
    :loading-structure="loadingStructure"
    :loading-save="loadingSave"
    :permission-name="form.permission"
    :object-type-translation-key="form.name_translation"
    :tabs="visibleTabs"
    :active-tab="activeTab"
    :action-type="actionType"
    :saveIsDisabled="!required.filled"
    :map-element="$parent.$refs.formsContainer"
    :previous-pos-x="previousPosX"
    :previous-pos-y="previousPosY"
    :data-was-changed="dataWasChanged"
    :fields-still-need-filled="required.stillNeedFilled"
    @updateActiveTab="activeTab = $event"
    @changeViewMode="changeViewModeOfObject"
    @openDetails="openDetails"
    @refresh="refresh"
    @clearData="clearData"
    @save="saveObject"
    @close="closeForm"
    :object-data="objectData"
  >
    <template v-slot:formFields>
      <custom-fields-tab
        v-if="visibleTabs[activeTab].code === 'custom_fields'"
        :customFields="customFields.custom_fields"
        :objectData="objectData.custom_fields"
        :actionType="actionType"
        :disabled="readOnly"
        @updateValue="setValueInObject"
        :requiredFilled="required.filled"
      />

      <div
        v-show="visibleTabs[activeTab].type === 'photos'"
        class="form tab-content"
      >
        <forms-photo-section
          :disabled="readOnly"
          :imagesList="imagesList"
          :previous-images="previousImages"
          @updatePhoto="updatePhoto($event)"
          @removePhoto="addToPhotosToRemove($event)"
        />
      </div>

      <div
        v-show="
          visibleTabs[activeTab].label === 'Masks' ||
            visibleTabs[activeTab].code === 'manhole_masks'
        "
        class="form tab-content"
      >
        <masks-tab
          :original-masks="objectData.masks"
          @update="setValueInObject('masks', $event)"
        />
      </div>

      <accessories-and-others-tab
        v-show="visibleTabs[activeTab].label === 'Accessories'"
        :accessories-selected="accessoriesSelected"
        :accessories-selected-by-material-id="accessoriesSelectedByMaterialId"
        relation-family-id-select="ch"
        family-id="ac"
        :disabled="readOnly"
      />
      <accessories-and-others-tab
        v-show="visibleTabs[activeTab].label === 'Others'"
        :accessories-selected="othersSelected"
        :accessories-selected-by-material-id="othersSelectedByMaterialId"
        relation-family-id-select="ch"
        family-id="ot"
        :disabled="readOnly"
      />

      <div
        v-show="visibleTabs[activeTab].type === 'form'"
        class="form tab-content"
      >
        <template v-for="field in visibleTabs[activeTab].fields">
          <input-field
            v-if="field.var_name === 'tp_material_id'"
            :key="visibleTabs[activeTab].code + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            inputType="other"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :hide="field.hide"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
          >
            <div>
              <treeselect
                :value="getValueInObject(field.var_name, field.input_type)"
                @input="
                  setValueInObject(field.var_name, $event, field.input_type)
                "
                :options="materialOptions"
                :load-options="loadMaterialOptions"
                :normalizer="materialOptionsNormalizer"
                :disabled="readOnly || field.disable"
                class="form-input-select"
                disableFuzzyMatching
              />
            </div>
          </input-field>
          <input-field
            v-else
            :key="visibleTabs[activeTab].code + field.label + field.order"
            ref="formInputField"
            :value="getValueInObject(field.var_name, field.input_type)"
            @input="setValueInObject(field.var_name, $event, field.input_type)"
            :label="field.label_client ? field.label_client : field.label"
            :variable-name="field.var_name"
            :inputType="field.input_type"
            :size="field.size"
            :required="field.required"
            :required-filled="required.filled"
            :selectOptions="field.select_list_name"
            :radioOptions="field.radio_options"
            :fieldDisabled="field.disable"
            :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
            :formDisabled="readOnly"
            :hide="field.hide"
            :automatic-label="field.has_automatic_label"
            @generateLabel="getAutomaticLabel(autoLabelRequestData)"
            :checkboxOptions="field.checkbox_options"
            :object-data="objectData"
            :labelIsLocked="objectData.tp_label_locked"
            :user-can-unlock-label="!userHasFibercloudPermission(form.permission + '_manage_label')"
            @toggle-label-lock="changeLabelMode"
            @updateCheckboxValue="updateCheckboxValue($event)"
            @removePhoto="addToPhotosToRemove($event)"
          />
        </template>
      </div>

      <asset-reservation-tab
        v-if="actionType !== 'create'"
        v-show="visibleTabs[activeTab].code === 'manhole_asset_reservation'"
        :endpoint="form.endpoint"
        :object-uuid="objectData.tp_uuid"
        :disabled="readOnly"
        :fields="visibleTabs[activeTab].fields"
      />
    </template>
  </dynamic-object-form-structure>
</template>

<script>
import { dynamicObjectFormsMixin } from "@/mixins/forms/dynamicObjectForms/dynamicObjectFormsMixin";
import InputField from "../_Molecules/InputField";
import FormsPhotoSection from "../_SpecialTabs/Photos/PhotosForm";
import DynamicObjectFormStructure from "../_Templates/DynamicObjectFormStructure";
import MasksTab from "../_SpecialTabs/Masks/Masks/MasksTab";
import { bus } from "@/main";
import AssetReservationTab from "@/components/Home/Forms/_SpecialTabs/AssetReservationTab/AssetReservationTab";
import AccessoriesAndOthersTab from "@/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersTab";
import CustomFieldsTab from "@/components/Home/Forms/_SpecialTabs/CustomFields/CustomFieldsTab.vue";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "ManholeForm",

  components: {
    AccessoriesAndOthersTab,
    AssetReservationTab,
    MasksTab,
    DynamicObjectFormStructure,
    FormsPhotoSection,
    InputField,
    CustomFieldsTab
  },

  mixins: [dynamicObjectFormsMixin,checkPermissionsMixin],

  props: {
    /**
     */
    linkObjectToPathway: {
      type: Object
    }
  },

  computed: {
    chamberTypeIsOther() {
      return this.objectData.tp_manhole_type === "OTH";
    },

    materialRequestQueryParameters() {
      return {
        material_family_id: "ch"
      };
    },

    masksTabStatus() {
      let module = this.$store.getters.modulesStates.find(
        module => module.permission_name === "module_faces"
      );
      return module && module.status;
    }
  },

  watch: {
    loadingStructure(newValue) {
      if (
        this.objectData.masks &&
        (this.objectData.masks.length === 0 || this.objectData.masks === "[]")
      ) {
        this.objectData.masks = [
          {
            mk_label: "A",
            mk_type: "dist",
            mk_default_destination_manhole_id: undefined,
            mk_default_destination_mask_id: undefined,
            duct_entries: []
          },
          {
            mk_label: "B",
            mk_type: "dist",
            mk_default_destination_manhole_id: undefined,
            mk_default_destination_mask_id: undefined,
            duct_entries: []
          },
          {
            mk_label: "C",
            mk_type: "dist",
            mk_default_destination_manhole_id: undefined,
            mk_default_destination_mask_id: undefined,
            duct_entries: []
          },
          {
            mk_label: "D",
            mk_type: "dist",
            mk_default_destination_manhole_id: undefined,
            mk_default_destination_mask_id: undefined,
            duct_entries: []
          }
        ];
      }
      if (!newValue) {
        this.objectData.coordinate_x = this.xCoordinate;
        this.objectData.coordinate_y = this.yCoordinate;
        this.getPreviousImages();
      }
    },

    chamberTypeIsOther() {
      let varName = "tp_manhole_type_other";
      let fields = this.form.tabs[0].fields;
      this.updateDependentFieldValueAndDisabledState(
        varName,
        this.chamberTypeIsOther,
        fields
      );
    },

    "objectData.tp_material_id"(newID) {
      this.updateMaterialDependentFields(newID);
    },

    materialOptions() {
      if (this.materialOptions && this.objectData.tp_material_id) {
        this.updateMaterialDependentFields(this.objectData.tp_material_id);
      }
    }
  },

  destroyed() {
    this.$store.dispatch("resetMasksState");
  },

  methods: {
    tabIsVisible(tab) {
      if (tab.label === "Masks" || tab.code === "manhole_masks") {
        this.setTabDisabled(
          !(this.userHasModulePermission("module_faces") && this.masksTabStatus)
        );
        return (
          this.userHasModulePermission("module_faces") && this.masksTabStatus
        );
      } else return true;
    },

    tabIsEnabled(tab) {
      return !(
        (tab.label === "Masks" ||
          tab.code === "manhole_masks" ||
          tab.code === "manhole_asset_reservation") &&
        this.actionType === "create"
      );
    },

    /**
     * Creates the manhole.
     * If the user is creating tech points in bulk the form is only closed and the
     * dataToSend is emitted and if there is a nextForm value the corresponding form
     * is opened
     */
    createObject() {
      this.createDataToSend();

      if (this.$attrs.creatingBulkTP) {
        this.updateObjectLocalStorageData();
        this.closeForm();
        this.$emit("update-tech-point-data", this.dataToSend);
        if (this.$attrs.nextForm) {
          this.$emit("open-next-form");
        }
      } else {
        this.CREATE_OBJECTS({
          endpoint: this.form.endpoint,
          data: [this.dataToSend]
        })
          .then(technicalPointData => {
            if (this.linkObjectToPathway.split) {
              bus.$emit("reset-pathway-and-split-data");
            }

            this.objectData.tp_label = this.incrementLabelSequential(
              this.objectData.tp_label
            );

            this.finishObjectCreation();
            if (this.$attrs.nextForm) {
              this.$emit("open-next-form", {
                createdTechPointData: technicalPointData.data.data[0],
                techPointGeom: this.dataToSend.node.text_geom
              });
            }
          })
          .catch(error => {
            if (error && error.response && error.response.data) {
              this.$toasted.global.toast_error(error.response.data.data);
            }
            this.loadingSave = false;
          });
      }
    },

    createDataToSend() {
      this.dataToSend = {
        node: { text_geom: this.wkt, projection: 3857 },
        status: this.objectData.tp_status,
        progress: this.objectData.tp_progress,
        physical_type: "C",
        technical_point_type: "C",
        logical_type: "T" //TODO - Remove when removed required from back-end
      };
      if (this.linkObjectToPathway.split) {
        this.dataToSend.node.delete_pathways_association = "false";
        this.dataToSend.node.pathway = this.linkObjectToPathway.pathway;
      }
      if (this.accessoriesSelected || this.othersSelected) {
        this.dataToSend.accessories = [];
        this.generateAccessoriesDataSend(this.accessoriesSelected);
        this.generateAccessoriesDataSend(this.othersSelected);
      }
      this.placeObjectDataInDataToSend();
    },

    updateMaterialDependentFields(materialID) {
      this.accessoriesSelectedByMaterialId = [];
      this.othersSelectedByMaterialId = [];
      if (materialID && this.materialOptions) {
        let materialOption = this.materialOptions.find(
          material => material.sm_id === materialID
        );
        if (materialOption) {
          this.getStockMaterial(materialOption)
            .then(material => {
              if (material.others) {
                this.generateAccessoriesAndOthersSelected(
                  this.accessoriesSelectedByMaterialId,
                  this.othersSelectedByMaterialId,
                  material.others
                );
              }
              if (material.family_specific_fields) {
                this.setValueInObject(
                  "tp_manhole_type",
                  material.family_specific_fields.smch_chamber_type
                );
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      } else {
        if (!this.dataReceived.tp_material_id) {
          this.setValueInObject(
            "tp_manhole_type",
            this.dataReceived.tp_manhole_type
          );
        } else {
          this.setValueInObject("tp_manhole_type", null);
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/ObjectForms/ManholeForm.vue